const INTERACTION_EVENTS = ["pointerdown", "keydown", "touchstart", "scroll", "wheel", "mousemove"]

/**
 * Runs `callback` once, on the visitor's first interaction, keeping third-party scripts
 * (GTM and everything it loads, Google One Tap) off the initial page load.
 * Returns a cleanup that cancels the pending callback.
 */
export function onFirstInteraction(callback: () => void): () => void {
  const cleanup = () => {
    INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, run))
  }
  const run = () => {
    cleanup()
    callback()
  }

  INTERACTION_EVENTS.forEach((event) => window.addEventListener(event, run, { passive: true }))
  return cleanup
}

/** Appends an async script once per `src`; `onLoad` runs once it has loaded. */
export function loadScript(src: string, onLoad?: () => void) {
  let script = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`)

  if (script?.dataset.loaded) {
    onLoad?.()
    return
  }

  if (!script) {
    script = document.createElement("script")
    script.src = src
    script.async = true
    script.addEventListener("load", () => {
      script!.dataset.loaded = "1"
    })
    document.head.appendChild(script)
  }

  if (onLoad) script.addEventListener("load", onLoad)
}
